export default __webpack_public_path__ + "static/media/Photo 1 - BR - Protections.66095a80.png";